const state = {
    incident_list: [],
    dni_search: '',
    selected_incident: null,

}
export default state;